import React from 'react';
import CurrencyFormat from 'react-currency-format';

const ThousandSeparatror = ({ value }) => <CurrencyFormat value={value} displayType='text' renderText={(formattedValue) => formattedValue} thousandSeparator />;

export default ThousandSeparatror;
